import React, {useState} from 'react'
import './index.scss'
import { useSelector} from "react-redux";
import useGetJobs from "../../../Global/Api/Jobs/getJobs.api";
import JobFormModal from "../../Modals/jobFormModal";

export default function JobForms() {
  const Jobs = useGetJobs();
  const { activeJob } = useSelector((state) => state.rootReducer.jobsSlice);
  const [showFormDetails, setShowFormDetails] = useState(false);

  const handleClickForm = (id) => {
    Jobs.getJobForm({jobId: activeJob?.id, formId: id});
    setShowFormDetails(true);
  };

  return (
    <div className="jobForms">
      <JobFormModal
        setShowFormDetails={setShowFormDetails}
        showFormDetails={showFormDetails}
      />
      <div className="jobForms__title">Job forms</div>
      <div className="jobForms__list">
        {
          activeJob?.job_forms?.length ? (
            activeJob?.job_forms?.map((form, index) => (
                <div
                  key={form?.id}
                  className="jobForms__item"
                  onClick={() => handleClickForm(form?.id)}
                >
                  <div className="jobForms__item-wrapper">
                    <div className="jobForms__item-avatar">
                      <img src="/assets/icons/forms.svg" alt="forms"/>
                    </div>
                    <div className="jobForms__item-info">
                      <p className="jobForms__item-name">
                        #{index + 1} -
                        {form?.vehicle_label ? ` ${form?.vehicle_label}` : `${form?.make} ${form?.model} ${form?.year}` }
                      </p>
                      <p className="jobForms__item-date">{form?.items_count} line items</p>
                    </div>
                  </div>
                </div>
            ))
          ) : (
            <div className="jobForms__empty">
              <div><img src="/assets/images/forms-empty.svg" alt="empty"/></div>
              <p className="jobForms__empty-text">
                Location where all forms for this job will be located. Also available in “My Vehicles”
              </p>
            </div>
          )
        }
      </div>
    </div>
  )
}
